import {Component, EventEmitter, Output, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
    MatSnackBar,
    MatChipInputEvent,
    MatAccordion,
    MatCheckboxChange,
    MatTabGroup
} from '@angular/material';
import {JsonEditorComponent, JsonEditorOptions} from "ang-jsoneditor";
import {AuthorizationComponent} from "../authorization/authorization.component";
import {HeadersComponent} from "../devex/headers/headers.component";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {LeftpanelComponent} from "../leftpanel/leftpanel.component";
import {ActivatedRoute, Router} from "@angular/router";
import {ConnecttocrudService} from "../connecttocrud.service";
import {ConfService} from "../conf.service";
import {Location} from "@angular/common";

declare let $;

@Component({
    selector: 'app-apiBrowser',
    templateUrl: '../testsuite/apiBrowser.component.html',
    styleUrls: ['../executeemailtemplate/executeemailtemplate.component.scss'],
})

export class ApiBrowserComponent{

    // httpUrl;
    // httpOperation;
    // // httpOperations = [
    // //     {'name': 'GET'},
    // //     {'name': 'POST'},
    // //     {'name': 'PUT'},
    // //     {'name': 'PATCH'},
    // //     {'name': 'DELETE'}
    // //     // {'name': 'COPY'},
    // //     // {'name': 'HEAD'},
    // //     // {'name': 'OPTIONS'},
    // //     // {'name': 'LINK'},
    // //     // {'name': 'UNLINK'},
    // //     // {'name': 'LOCK'},
    // //     // {'name': 'UNLOCK'},
    // //     // {'name': 'PROPFIND'},
    // //     // {'name': 'PURGE'},
    // //     // {'name': 'VIEW'}
    // // ];
    // // headersData=[];
    // // showAPIBrowser=false;
    // // DisplayApiByCategory=true;
    // // basicPermission=true;
    //
    //
    // getBackgroundStyle(val) {
    //     if (val === 'GET') {
    //         return 'get-method';
    //     } else if (val === 'PUT') {
    //         return 'put-method';
    //     } else if (val === 'POST') {
    //         return 'post-method';
    //     } else if (val === 'DELETE') {
    //         return 'delete-method';
    //     } else {
    //         return 'get-method';
    //     }
    // }
    //
    // selectAPI() {
    //     $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
    //     $('#apiBrowser').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
    //     $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
    //     this.showAPIBrowser = false;
    // }
    //
    // collapsePanel() {
    //     $('#collapsablePanel').css('display', 'none');
    //     $('#apiBrowser').removeClass('col-md-9 col-lg-9 col-sm-12 col-xs-12').addClass('col-md-12 col-lg-12 col-sm-12 col-xs-12');
    //     $('.URL-Field').removeClass('col-lg-9 col-md-9').addClass('col-lg-7 col-md-7');
    //     this.showAPIBrowser = true;
    // }




    isLinear = true;
    // firstFormGroup: FormGroup;
    // secondFormGroup: FormGroup;
    // thirdFormGroup: FormGroup;
    // fourthFormGroup: FormGroup;
    // fifthFormGroup: FormGroup;

    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');

    // subject = '';
    // authorizedMails = [
    //     {
    //         email: 'admin@confap.in'
    //     }
    // ];
    // recipientModes = [
    //     {
    //         mode: 'manual',
    //         displayName: 'Enter Manually'
    //     },
    //     {
    //         mode: 'csv',
    //         displayName: 'Upload CSV'
    //     },
    //     {
    //         mode: 'subscribers',
    //         displayName: 'Select from Subscriber List'
    //     },
    //     {
    //         mode: 'copyPaste',
    //         displayName: 'Comma Separated TO List'
    //     },
    //     {
    //         mode: 'API',
    //         displayName: 'Execute an API'
    //     }
    //     // {
    //     //     mode: 'integrations',
    //     //     displayName: 'Integrate from 3rd party services'
    //     // }
    // ];

    // selectedAPICallMode = 'Configure an API';
    // APICallModes = [
    //     {
    //         mode: 'Configure an API'
    //     },
    //     {
    //         mode: 'Use my API'
    //     }
    // ];
    // modeOfManualEntry: any;

    // selectedTab: any;
    // selectedTemplate: any;
    // templateBody: any;
    // recipientMode: string;
    // templateName: string;
    // templates = [];
    columns = [];
    // items = [];
    // emailIndexInCSV: number;
    // payloadToSend = {
    //     serverConfig: {},
    //     from: {
    //         name: '',
    //         email: ''
    //     },
    //     to: {
    //         type: ''
    //     },
    //     subject: '',
    //     body: {
    //         type: 'Simple Text',
    //         value: []
    //     },
    //     partner: localStorage.getItem('partner'),
    //     account: localStorage.getItem('account')
    // };
    parameters = [];
    showParameters = false;
    templateParameters = [];
    recipientSpecificParameters = [];

    recipientSpecificParametersPayload = [];
    dummyPayload = {};
    count = 0;

    httpOperation: any;
    httpOperations = [
        {'name': 'GET'},
        {'name': 'POST'},
        {'name': 'PUT'},
        {'name': 'PATCH'},
        {'name': 'DELETE'}
        // {'name': 'COPY'},
        // {'name': 'HEAD'},
        // {'name': 'OPTIONS'},
        // {'name': 'LINK'},
        // {'name': 'UNLINK'},
        // {'name': 'LOCK'},
        // {'name': 'UNLOCK'},
        // {'name': 'PROPFIND'},
        // {'name': 'PURGE'},
        // {'name': 'VIEW'}
    ];
    httpUrl: string;
    parametersHeaders = ['key', 'value', 'description'];
    parameterData = [];
    pathParameter = [];
    headersData = [];
    formData = [];
    requestBodySelected = 'none';
    confirmationWithoutResponseAttributes = {confirmation: ''};
    requestBodyTypes = [
        {'displayName': 'None', 'value': 'none'},
        {'displayName': 'Form Data', 'value': 'form-data'},
        {'displayName': 'Form URL Encoded', 'value': 'x-www-form-urlencoded'},
        {'displayName': 'Raw', 'value': 'raw'},
        {'displayName': 'Binary / File', 'value': 'binary'}

    ];

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;
    @ViewChild(HeadersComponent) headerChild: HeadersComponent;
    @ViewChild('tabref4') tabref4: MatTabGroup;
    @Output() onCompletingTestCases: EventEmitter<any> = new EventEmitter<any>()

    options1 = new JsonEditorOptions();

    showPathParameters: boolean;
    devExURL = '';
    isCountOfResAtt: boolean;
    pathParameterSegregator: any;
    find: any;
    pathParameterStopper: any;
    pathParameterValue: any;

    requestBody: any;
    rawRequestBody: any;

    authAttributes = {};
    authModel = {
        'authAttributes': this.authAttributes
    };

    formDataTrue = true;
    formURLEncodedTrue = true;

    responseData: any;
    errorMessage: any;
    responseError: any;

    executorName: string;
    executorVersion: string;
    executor_url: string;
    executor_name: string;
    executor_version: string;
    executor_type = 'API';
    executor_method_type: string;
    executors: any;

    apiByDefinition: any;
    categories: any;
    entities = [];

    APIExecutorCategory = [];
    businessLogicAPIExecutorCategory = [];
    thirdPartyAPIExecutorCategory = [];
    SQLQueryAPIExecutorCategory = [];
    WorkflowAPIExecutorCategory = [];

    DataAccessAPIByCategory = [];
    businessLogicAPIByCategory = [];
    thirdPartyAPIByCategory = [];
    SQLQueryAPIByCategory = [];
    WorkflowAPIByCategory = [];

    basicPermission: boolean;

    DisplayApiByCategory = true;

    APITypes = [
        {
            type: 'Data Access API',
            category: this.APIExecutorCategory
        },
        {
            type: 'Business Logic API',
            category: this.businessLogicAPIExecutorCategory
        },
        {
            type: 'Third Party API',
            category: this.thirdPartyAPIExecutorCategory
        },
        {
            type: 'SQL Query API',
            category: this.SQLQueryAPIExecutorCategory
        },
        {
            type: 'Workflow API',
            category: this.WorkflowAPIExecutorCategory
        }
    ];

    delimiters = [
        {
            delimiter: ':'
        },
        {
            delimiter: ','
        }
    ];
    selectedDelimiter = ',';

    commaSeparatedList: any;

    DAASExecutors: any;
    businessLogicExecutors: any;
    sqlQueryExecutors: any;
    workFlowExecutors: any;

    apisByCategory: any;
    dataAccess = [];
    businessLogic = [];
    sql = [];
    workflow = [];
    decision = [];

    DisplayCustomOperation = true;
    executor: any;

    headers = [];
    queryParams = [];
    prerequisites: any;
    showAPIBrowser = true;

    itemList = [];
    filterData: any[];
    settings = {
        text: 'Select attribute(s) to search instantly',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: true,
        autoPosition: false
    };
    searchText: string;
    subscriberColumns = [];
    subscribersColumnsLength: number;
    subscribersData: any;
    selectAll = false;
    subscribersChecked = [];
    settingsData: any;

    readonly separatorKeysCodes: number[] = [ENTER, COMMA];

    constructor(public platform: LeftpanelComponent, private route: ActivatedRoute, private _service: ConnecttocrudService, public dialog: MatDialog, private confPost: ConfService, private _formBuilder: FormBuilder, private location: Location, public router: Router) {
    }

    async ngOnInit() {

        this.getCategoriesEntitiesForPartner();
        this.getBusinessLogicApiExecutorsByPartnerAccountType();
        this.getThirdPartyApiExecutorsByPartnerAccountType();
        this.getSqlQueryApiExecutorsByPartnerAccountType();
        this.getWorkFlowApiExecutorsByPartnerAccountType();
        this.basicPermission = true;

        this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'))
            .toPromise().then(data => {
            let apiExecutors: any;
            apiExecutors = data;
            const tempCategoryarray = [];
            const tempCategoryarray1 = [];
            const tempCategoryarray2 = [];
            const tempCategoryarray3 = [];

            for (let i = 0; i < apiExecutors.length; i++) {
                for (let j = 0; j < apiExecutors[i]['executors'].length; j++) {
                    switch (apiExecutors[i]['executors'][j]['executor_type']) {
                        case 'API':
                            const apiName = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray.includes(apiName) === false) {
                                tempCategoryarray.push(apiName);
                                this.APIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName
                                    });
                                this.DataAccessAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'WORKFLOW':
                            const apiName1 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray1.includes(apiName1) === false) {
                                tempCategoryarray1.push(apiName1);
                                this.WorkflowAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName1
                                    });
                                this.WorkflowAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'BUSINESSLOGIC':
                            const apiName2 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (tempCategoryarray2.includes(apiName2) === false) {
                                tempCategoryarray2.push(apiName2);
                                this.businessLogicAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName2
                                    });
                                this.businessLogicAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;
                        case 'SQLQUERY':
                            const apiName3 = apiExecutors[i]['executors'][j]['executor_category'] + '_' + apiExecutors[i]['executors'][j]['executor_version'];
                            if (this.businessLogicAPIExecutorCategory.includes(apiName3) === false) {
                                tempCategoryarray3.push(apiName3);
                                this.businessLogicAPIExecutorCategory.push(
                                    {
                                        'category': apiExecutors[i]['executors'][j]['executor_category'],
                                        'version': apiExecutors[i]['executors'][j]['executor_version'],
                                        'categoryAndVersion': apiName3
                                    });
                                this.SQLQueryAPIByCategory[apiExecutors[i]['executors'][j]['executor_category']] = [];
                            }
                            break;

                    }
                }
            }

        });

        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            for (let i = 0; i < this.categories.length; i++) {
                                for (let j = 0; j < this.categories[i].entities.length; j++) {
                                    const tempJSON = {};
                                    tempJSON['entity'] = this.getEntity(this.categories[i].entities[j]);
                                    tempJSON['version'] = this.getVersion(this.categories[i].entities[j]);
                                    this.entities.push(tempJSON);
                                }
                            }
                        }
                    });
                }
            });

        this.apiByDefinition = [{
            'customType': false,
            'apiAccessPolicy': 'None',
            'attributeName': null,
            'type': null,
            'array': false,
            'size': null,
            'precision': null,
            'autoIncrement': false,
            'defaultValue': null,
            'attributeType': 'None',
            'dataStoragePolicy': 'None',
            'description': null,
            'displayName': null,
            'displayPolicy': 'None',
            'required': false,
            'subType': []

        }];
    }

    showOptions(event: MatCheckboxChange, index): void {
        if (event.checked) {
            this.subscribersChecked.push(this.subscribersData[index]);
        } else {
            for (let i = 0; i < this.subscribersChecked.length; i++) {
                if (this.subscribersChecked[i]['email'] === this.subscribersData[index]['email']) {
                    this.subscribersChecked.splice(i, 1);
                }
            }
        }
    }

    getCategoriesEntitiesForPartner() {
        // if (this.categories.length === 0) {
        this.confPost.getCategoriesEntitiesForPartner(localStorage.getItem('partner'), localStorage.getItem('account'))
            .subscribe(data => {
                if (data[0].accounts != null) {
                    data[0].accounts.forEach((accounts) => {
                        if (accounts.categories != null) {
                            this.categories = accounts.categories;
                            if (this.categories && this.categories.length > 0) {
                                this.DisplayApiByCategory = true;
                                this.DisplayCustomOperation = true;
                            } else {
                                this.DisplayApiByCategory = false;
                                this.DisplayCustomOperation = false;
                            }
                        }
                    });
                }
            });
        // }
    }

    async getBusinessLogicApiExecutorsByPartnerAccountType() {
        if (this.platform.businessLogicExecutors !== null && this.platform.businessLogicExecutors !== undefined && this.platform.businessLogicExecutors !== '') {
            this.businessLogicExecutors = this.platform.businessLogicExecutors;
        } else {
            await this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'BUSINESSLOGIC').toPromise().then(data => {
                this.businessLogicExecutors = data;
                this.platform.businessLogicExecutors = data;
                // localStorage.setItem('businessLogicAPI' , JSON.stringify(this.executors));
            }, error => {
                this.platform.openSnackBar('Error while Business Logic APIs', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }

    }
    getThirdPartyApiExecutorsByPartnerAccountType() {
        // this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'THIRDPARTY').subscribe(data => {
        //     this.thirdPartyApiExecutors = data;
        //     // localStorage.setItem('dataAccessAPI' , JSON.stringify(this.apiExecutors));
        // });
        this.confPost.getApiExecutorsForPartnerAccount(this.partner, this.account).subscribe(data => {
            // this.thirdPartyApiExecutors = data;
            this.apisByCategory = data;
            for ( let i = 0 ; i < this.apisByCategory.length ; i++) {
                const tempDataAccess = [];
                const tempbusinessLogic = [];
                const tempsql = [];
                const tempworkflow = [];
                const tempdecision = [];
                for ( let j = 0 ; j <  this.apisByCategory[i]['executors'].length ; j++) {
                    let temp: string;
                    temp = '';
                    if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'API') {
                        tempDataAccess.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'BUSINESSLOGIC') {
                        tempbusinessLogic.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'SQLQUERY') {
                        tempsql.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'WORKFLOW') {
                        tempworkflow.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    } else if (this.apisByCategory[i]['executors'][j]['executor_type'] === 'DECISION') {
                        tempdecision.push(this.apisByCategory[i]['executors'][j]['executor_name'] + '#' + this.apisByCategory[i]['executors'][j]['executor_version']);
                    }
                }
                if (tempDataAccess.length > 0) {
                    this.dataAccess.push({'executors': tempDataAccess, 'category': this.apisByCategory[i]['category']});
                }
                if (tempbusinessLogic.length > 0) {
                    this.businessLogic.push({'executors': tempbusinessLogic, 'category': this.apisByCategory[i]['category']});
                }
                if (tempsql.length > 0) {
                    this.sql.push({'executors': tempsql, 'category': this.apisByCategory[i]['category']});
                }
                if (tempworkflow.length > 0) {
                    this.workflow.push({'executors': tempworkflow, 'category': this.apisByCategory[i]['category']});
                }
                if (tempdecision.length > 0) {
                    this.decision.push({'executors': tempdecision, 'category': this.apisByCategory[i]['category']});
                }
            }
        });
    }
    getSqlQueryApiExecutorsByPartnerAccountType() {
        if (this.platform.sqlQueryExecutors !== null && this.platform.sqlQueryExecutors !== undefined && this.platform.sqlQueryExecutors !== '') {
            this.sqlQueryExecutors = this.platform.sqlQueryExecutors;
        } else {
            this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'SQLQUERY').subscribe(data => {
                this.sqlQueryExecutors = data;
                this.platform.sqlQueryExecutors = data;
                // localStorage.setItem('sqlQueryAPI' , JSON.stringify(this.sqlQueryExecutors));
            }, error => {
                this.platform.openSnackBar('Error while fetching SQL Query APIs', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }
    }
    getWorkFlowApiExecutorsByPartnerAccountType() {
        if (this.platform.workFlowExecutors !== null && this.platform.workFlowExecutors !== undefined && this.platform.workFlowExecutors !== '') {
            this.workFlowExecutors = this.platform.workFlowExecutors;
        } else {
            this.confPost.getApiExecutorsByPartnerAccountType(this.partner, this.account, 'WORKFLOW').subscribe(data => {
                this.workFlowExecutors = data;
                this.platform.workFlowExecutors = this.workFlowExecutors;
                // localStorage.setItem('workFlowAPI' , JSON.stringify(this.workFlowExecutors));
            }, error => {
                this.platform.openSnackBar('Error while fetching Workflow APIs.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }
    }

    getMenu(val) {
        if (val != null) {
            return val.replace(/ /g, '');
        } else {
            return 'Default';
        }

    }

    getEntity(val) {
        const data = val.split('#');
        return data[0];
    }

    getVersion(val) {
        const data = val.split('#');
        return data[1];
    }


    getBackgroundStyle(val) {
        if (val === 'GET') {
            return 'get-method';
        } else if (val === 'PUT') {
            return 'put-method';
        } else if (val === 'POST') {
            return 'post-method';
        } else if (val === 'DELETE') {
            return 'delete-method';
        } else {
            return 'get-method';
        }
    }


    // getRequestBodyValue(val) {
    //     switch (val) {
    //         case 'raw':
    //             // return JSON.stringify(this.editor.get());
    //             return this.editor.get();
    //         case 'binary':
    //         case 'none':
    //         default:
    //     }
    // }

    // getRequestBody() {
    //
    //     if (this.requestBodySelected === 'raw') {
    //         const requestbody = {
    //             'value': this.getRequestBodyValue(this.requestBodySelected),
    //             'key': 'payload',
    //             'description': 'Document in JSON format',
    //             'annotation': 'RequestBody'
    //         };
    //         return requestbody;
    //     } else if (this.requestBodySelected === 'form-data') {
    //         const requestbody = {
    //             'value': this.formData,
    //             'key': 'payload',
    //             'description': 'Document in JSON format',
    //             'annotation': 'RequestBody'
    //         };
    //         return requestbody;
    //     } else if (this.requestBodySelected === 'x-www-form-urlencoded') {
    //         const requestbody = {
    //             'value': this.formData,
    //             'key': 'payload',
    //             'description': 'Document in JSON format',
    //             'annotation': 'RequestBody'
    //         };
    //         return requestbody;
    //     } else if (this.requestBodySelected === 'none') {
    //         const requestbody = null;
    //         return requestbody;
    //     }
    //
    // }
    //
    // executeApiAndLoadResponse() {
    //     this.responseData = '';
    //     this.errorMessage = '';
    //     this.responseError = '';
    //
    //     const payload = {
    //         'executor_name': this.executor_name,
    //         'executor_type': this.executor_type !== null ? this.executor_type : 'API',
    //         'executor_version': this.executor_version,
    //         'executor_method_type': this.httpOperation,
    //         'apiUrl': this.httpUrl,
    //         'queryParams': this.parameterData,
    //         'pathParams': this.pathParameter,
    //         'headers': this.headersData,
    //         'authModel': this.authModel,
    //         'requestBody': this.getRequestBody(),
    //         'executors': this.executors,
    //     };
    //     if (!(payload.authModel.hasOwnProperty('authType') && payload.authModel['authType'] !== 'no_auth')) {
    //         payload.authModel = null;
    //     }
    //     this.confPost.getResponseAttribute(localStorage.getItem('partner'), localStorage.getItem('account'), payload).subscribe(response => {
    //         this.apiByDefinition = response;
    //     });
    // }

    collapsePanel() {
        $('#collapsablePanel').css('display', 'none');
        $('#devexGeneric').removeClass('col-md-9 col-lg-9 col-sm-12 col-xs-12').addClass('col-md-12 col-lg-12 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-9 col-md-9').addClass('col-lg-7 col-md-7');
        this.showAPIBrowser = true;

    }

    selectAPI() {
        $('#collapsablePanel').addClass('col-md-3 col-lg-3 col-sm-12 col-xs-12').css('display', 'block');
        $('#devexGeneric').removeClass('col-md-12 col-lg-12 col-sm-12 col-xs-12').addClass('col-md-9 col-lg-9 col-sm-12 col-xs-12');
        $('.URL-Field').removeClass('col-lg-7 col-md-7').addClass('col-lg-9 col-md-9');
        this.showAPIBrowser = false;


    }


    onAddingTestCase(testCases){
        this.onCompletingTestCases.emit(testCases)
    }

    toggleExecutorWithID(ev, id) {
        $(id).slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }

    parameterDataCheck(event: any) {
        // /: calculation
        if (this.devExURL !== event.target.value) {
            this.devExURL = event.target.value;
            this.pathParameterSegregator = this.devExURL.split('/:');
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterStopper = this.pathParameterSegregator[i].split('/');
                this.pathParameterSegregator[i] = this.pathParameterStopper[0];
            }
            // {} for calculation
            let temp2 = this.devExURL.split('/');
            // /: append
            this.pathParameter = [];
            for (let i = 1; i < this.pathParameterSegregator.length; i++) {
                this.pathParameterValue = this.pathParameterSegregator[i];
                this.find = true;
                for (let j = 0; j < this.pathParameter.length; j++) {
                    if (this.pathParameterSegregator[i] === this.pathParameter[j]['key']) {
                        this.find = false;
                    }
                }
                if (this.find === true) {
                    this.pathParameter.push({'key': this.pathParameterValue, 'value': '', 'description': ''});
                }
            }
            // {} append
            for (let i = 2; i < temp2.length; i++) {
                const init = temp2[i].indexOf('{');
                const fin = temp2[i].indexOf('}');
                if ((!(this.pathParameter.some(e => e.key === temp2[i].substr(init + 1, fin - init - 1))) && temp2[i].substr(init + 1, fin - init - 1) !== '') && init !== -1 && fin !== -1) {
                    this.pathParameter.push({
                        'key': temp2[i].substr(init + 1, fin - init - 1),
                        'value': '',
                        'description': ''
                    });
                }
            }
            // confirm to show the path parameter area.
            if (this.pathParameter.length !== 0) {
                this.showPathParameters = true;
            } else {
                this.showPathParameters = false;
            }
        }
    }

    checkQueryParams(event) {
        const tempUrl = event.target.value;
        const seperator = tempUrl.split('/');
        let query: any;
        let finalquery: any;
        if (seperator.length > 0) {
            query = seperator[seperator.length - 1].split('?');
            if (query.length > 1) {
                finalquery = query[query.length - 1].split('&');
                if (finalquery) {
                    for (let i = 0; i < finalquery.length; i++) {
                        let temp = finalquery[i].split('=');
                        let flag = false;
                        for (let j = 0; j < this.parameterData.length; j++) {
                            if (temp[0].includes(this.parameterData[j]['key']) || this.parameterData[j]['key'].includes(temp[0]) || this.parameterData[j]['key'] === temp[0]) {
                                flag = true;
                                if (temp.length > 1) {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = temp[1];
                                } else {
                                    this.parameterData[j]['key'] = temp[0];
                                    this.parameterData[j]['value'] = '';
                                }
                            }
                        }
                        if (flag === false) {
                            if (temp.length > 1) {
                                this.parameterData.push({key: temp[0], value: temp[1], description: ''});
                            } else {
                                this.parameterData.push({key: temp[0], value: '', description: ''});
                            }
                        }
                    }
                }
            }
        }
    }

    fetchExecutor(item) {
        this.confPost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.getEntity(item), this.getVersion(item)).subscribe(exec => {
            this.executor = exec;
            this.httpUrl = this.executor.apiUrl;
            this.executor_name = this.executor.executor_name;
            this.executor_version = this.executor.executor_version;
            this.executor_type = this.executor.executor_type;
            this.executor_method_type = this.executor.executor_method_type;
            this.httpOperation = this.executor.executor_method_type;
            this.parameterData = this.executor.queryParams;
            this.pathParameter = this.executor.pathParams;
            this.authModel = this.executor.authModel;
            this.headersData = this.executor.headers;
            for (const header of this.headersData) {
                if (header['key'] === 'Content-Type') {
                    switch (header['value']) {
                        case 'multipart/form-data':
                            this.requestBodySelected = 'form-data';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = true;
                            this.formURLEncodedTrue = false;
                            break;
                        case 'application/x-www-form-urlencoded':
                            this.requestBodySelected = 'x-www-form-urlencoded';
                            this.formData = this.executor.requestBody.value;
                            this.formDataTrue = false;
                            this.formURLEncodedTrue = true;
                            break;
                        case 'application/json':
                            this.requestBodySelected = 'raw';
                            this.rawRequestBody = this.executor.requestBody.value;
                            break;
                        default:
                            this.requestBodySelected = 'none';
                            break;
                    }
                }
            }
            this.requestBody = this.executor.requestBody;
            this.executors = this.executor.executors;
            if (this.executor.responseAttributes !== null) {
                this.apiByDefinition = this.executor.responseAttributes;
            }
        });
    }

}
